import Service from '../Service';
import { addFingerprintToRequest } from './utils';
import Request from '../Request';
import { ResponseErrorBody, RequestParamsChangepassword } from '../../types';

export default async function(params: RequestParamsChangepassword) {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsChangepassword>('/api/auth/changepassword')
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
